export default {
  testimonial: {},
};
